import * as React from "react";
import * as CopyToClipboard from "react-copy-to-clipboard";
import {InjectedIntlProps, injectIntl} from "react-intl";

import { shortenTo } from 'src/utils/stringManipulation';
import GeneratorEntity from "../../../models/Generator";
import { tokenApiManager, tokenFunctions } from '../../../utils/api';
// import translations from "./../../../translations";

interface IProps extends InjectedIntlProps {
    tokenManager: {
        showTokenModal: boolean,
        generator: GeneratorEntity
    },

    modalCloseHandler: () => void;
}

interface IState {
    tokenList: string[]
}


class TokenManager extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            tokenList: []
        }
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.tokenManager.generator.id !== "-1") {
            tokenApiManager(tokenFunctions.getList, nextProps.tokenManager.generator)
            .then( (result) => {
                if (result !== undefined && result !== null) {
                    this.setState({
                        tokenList: result.data,
                    })
                };
            })
        }
    }

    public updateList = () => {
        tokenApiManager(tokenFunctions.getList, this.props.tokenManager.generator)
            .then( (result) => {
                if (result !== undefined && result !== null) {
                    this.setState({
                        tokenList: result.data,
                    })
                };
            })
            // .catch((error) => {})
    } 

    public createToken = () => {
        tokenApiManager(tokenFunctions.create, this.props.tokenManager.generator)
            .then( (result) => {
                this.updateList();
            })
            // .catch((error) => {})
    }

    public deleteToken = (token: string) => {
        tokenApiManager(tokenFunctions.deleteToken, this.props.tokenManager.generator, token)
            .then( () => {
                this.updateList();
            })
            // .catch(error => {})
            this.updateList();
    }
    
    

    public render () {

        return (
          <div className={"modal " + (this.props.tokenManager.showTokenModal ? 'is-active' : '')}>
                <div className="modal-background" onClick={this.props.modalCloseHandler} />
                <div className="modal-card is-danger" style={{width: "75%", height: "100%"}}>
                  <header className="modal-card-head">
                    {/* <p className="modal-card-title">{this.props.intl.formatMessage(translations.uploadModalTitle)}</p> */}
                    <p className="modal-card-title">Manage Execute Tokens</p>
                    <button className="delete" aria-label="close" onClick={this.props.modalCloseHandler} />
                  </header>
                  <section className="modal-card-body">
                  
                  <table className="table">
                      <tbody>
                    {this.state.tokenList.map( (token: string, index: number) => (
                        <tr key={token}>
                            <td>{index+1}</td>
                            <td>{shortenTo(token, 15)}</td>
                            <td>
                            <div className="field has-addons">
                                <p className="control">
                                    <a className="button is-danger" onClick={() => this.deleteToken(token)}>{/* tslint:disable-line */}
                                    <span className="icon is-small">
                                        <i className="fas fa-trash"/>
                                    </span>
                                    </a>
                                </p>
                                <p className="control">
                                    <CopyToClipboard text={token}>
                                    <a className="button" >
                                    <span className="icon is-small">
                                        <i className="fas fa-align-center"/>
                                    </span>
                                    <span>Copy Token</span>
                                    </a>
                                    </CopyToClipboard>
                                </p>
                                <p className="control">
                                    <CopyToClipboard text={`https://generator.campaign-logger.com/execute/${token}`}>
                                    <a className="button" >
                                    <span className="icon is-small">
                                        <i className="fas fa-link"/>
                                    </span>
                                    <span>Copy Link</span>
                                    </a>
                                    </CopyToClipboard>
                                </p>
                                </div>
                            </td>
                        </tr>
                    ))}  
                    </tbody>
                  </table>
                  </section>
                  <footer className="modal-card-foot">
                    <button className="button" onClick={this.props.modalCloseHandler}>Close</button>
                    <button className="button" onClick={this.createToken}>Create New!</button>
                  </footer>
                </div>
              </div>
        );
    }
};

export default injectIntl(TokenManager);



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/TokenManager.tsx